import type { ComputedRef } from "vue";

/**
 * Masque la scrollbar quand la page est rendue dans une iframe d'aperçu
 * (mode preview du dashboard). Le scroll reste actif. Restaure les styles
 * d'origine au démontage.
 */
export function usePreviewScrollbar(isPreviewMode: ComputedRef<boolean>): void {
  onMounted(() => {
    if (!isPreviewMode.value) return;
    document.documentElement.style.setProperty("scrollbar-width", "none");
    document.body.style.setProperty("-ms-overflow-style", "none");
    const style = document.createElement("style");
    style.id = "preview-scrollbar-hide";
    style.textContent = `
    ::-webkit-scrollbar { display: none !important; width: 0 !important; }
    html, body { -ms-overflow-style: none; scrollbar-width: none; }
  `;
    document.head.appendChild(style);
  });

  onBeforeUnmount(() => {
    if (!isPreviewMode.value) return;
    document.documentElement.style.removeProperty("scrollbar-width");
    document.body.style.removeProperty("-ms-overflow-style");
    const style = document.getElementById("preview-scrollbar-hide");
    if (style) style.remove();
  });
}
